import { useRef, useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

// Check for updates every 5 minutes
const UPDATE_CHECK_INTERVAL = 5 * 60 * 1000;

// De nieuwe service worker claimt de openstaande pagina's (clientsClaim). Die
// pagina's draaien dan nog wél de oude JS, dus herlaad zodra de overname een
// feit is. Eén keer -- zonder deze vlag herlaadt een claim-storm eindeloos.
function herlaadBijOvername() {
  if (!('serviceWorker' in navigator)) return;
  let herladen = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (herladen) return;
    herladen = true;
    window.location.reload();
  });
}

export function useServiceWorker() {
  const registrationRef = useRef(null);

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW registered:', r);
      registrationRef.current = r;
      // Check for updates immediately on app start
      if (r) {
        console.log('Checking for updates on start...');
        r.update();
      }
    },
    onRegisterError(error) {
      console.log('SW registration error:', error);
    },
  });

  useEffect(herlaadBijOvername, []);

  // Periodic update check
  useEffect(() => {
    const interval = setInterval(() => {
      if (registrationRef.current) {
        console.log('Periodic update check...');
        registrationRef.current.update();
      }
    }, UPDATE_CHECK_INTERVAL);

    // Also check when app becomes visible (user returns to tab/app)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && registrationRef.current) {
        console.log('App visible, checking for updates...');
        registrationRef.current.update();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const updateApp = () => {
    updateServiceWorker(true);
  };

  const checkForUpdates = () => {
    if (registrationRef.current) {
      console.log('Manual update check...');
      registrationRef.current.update();
    }
  };

  return {
    updateAvailable: needRefresh,
    updateApp,
    checkForUpdates
  };
}
